import z from "zod";
//
// Read
//
export const DTOScimTokenCreatedBy = z.object({
    userId: z.string(),
    name: z.string(),
    avatar: z.string().optional(),
});
export const DTOScimToken = z.object({
    id: z.string(),
    name: z.string(),
    tokenPreview: z.string(),
    workspaceId: z.string(),
    createdBy: DTOScimTokenCreatedBy.optional(),
    createdAt: z.coerce.date(),
});
export const DTOScimTokenListResponse = z.object({
    tokens: z.array(DTOScimToken),
});
export const DTOScimTokenCreateResponse = z.object({
    token: DTOScimToken,
    tokenString: z.string(),
});
export const DTOScimTokenDeleteResponse = z.object({
    ok: z.literal(true),
});
//
// Write
//
export const DTOScimTokenCreatePayload = z.object({
    name: z.string(),
});
